import Input from './Input';
import { useTranslation } from 'react-i18next';

const Filter = ({ filters, onFilterChange, resetFilters, filterValues, applyFilterChanges, showApplyButton }) => {
  const { t } = useTranslation();

  const renderFilterField = (filter) => {
    return (
      <Input
        key={filter.name}
        type={filter.type || 'text'}
        label={filter.label}
        name={filter.name}
        options={filter.options || []}
        value={filterValues[filter.name] || ''}
        onChange={(value) => onFilterChange(filter.name, value)}
        context="filter"
        isDashboardFilter={filter.isDashboardFilter}
        get={filter.get}
      />
    );
  };

  const totalFilters = filters.length;
  let firstRowFilters = [];
  let secondRowFilters = [];

  if (totalFilters > 6) {
    const splitIndex = totalFilters % 2 === 0 ? totalFilters / 2 : Math.ceil((totalFilters + 1) / 2);
    firstRowFilters = filters.slice(0, splitIndex);
    secondRowFilters = filters.slice(splitIndex);
  } else {
    firstRowFilters = filters;
    secondRowFilters = [];
  }
  const missingPlaceholders = firstRowFilters.length - secondRowFilters.length;
  const placeholders = missingPlaceholders > 0
    ? Array.from({ length: missingPlaceholders }, (_, i) => (
        <div
          key={`placeholder-${i}`}
          style={{ flex: '1 1 calc(15% - 1rem)', minWidth: '150px' }}
        />
      ))
    : null;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-end items-center gap-4">
        {showApplyButton && (
          <button
            className="text-[#6B78F8] text-sm font-medium cursor-pointer hover:underline"
            onClick={applyFilterChanges}
          >
            {t(`actions.apply`)}
          </button>
        )}
        <span
          className="text-[#6B78F8] text-sm font-medium cursor-pointer hover:underline"
          onClick={resetFilters}
        >
          {t(`actions.reset`)}
        </span>
      </div>

      <div>
        {/* First Row */}
        <div className="flex flex-wrap gap-4 items-center">
          {firstRowFilters.map((filter) => renderFilterField(filter))}
        </div>

        {/* Second Row, if applicable */}
        {secondRowFilters.length > 0 && (
          <div className="flex flex-wrap gap-4 items-center mt-4">
            {secondRowFilters.map((filter) => renderFilterField(filter))}
            {placeholders}
          </div>
        )}
      </div>
    </div>
  );
};

export default Filter;
